export default __webpack_public_path__ + "static/media/folder-cloud.bf53c161.svg";